'use strict';

window.CFC = window.CFC || {};
window.CFC.Theme = (function($) {
  function print(objType, id) {
    if (window.ga) {
      window.ga('send', 'event', 'Print', objType, id);
    }
    
    window.print();
  }
  
  return {
    print: print
  }
})(jQuery);  
